import { NgModule } from '@angular/core';
import { AsyncAutocompleteComponent } from './async-autocomplete.component';

@NgModule({
  imports: [AsyncAutocompleteComponent],
  exports: [AsyncAutocompleteComponent]
})
export class AsyncAutocompleteModule {}
